import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export const ProtectedRoute = ({ children, permission }) => {
  const navigate = useNavigate();
  const [showMessage, setShowMessage] = useState(true);

  const permissions = JSON.parse(localStorage.getItem("permissions")) || [];

  const unauthorized = permission && !permissions.includes(permission);

  useEffect(() => {
    if (unauthorized) {
      const timer = setTimeout(() => {
        navigate(-1); // 👈 Laravel "back()" equivalent
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [unauthorized, navigate]);

  if (unauthorized && showMessage) {
    return (
      <div
        style={{
          height: "100vh",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          textAlign: "center",
          flexDirection: "column",
        }}
      >
        <h2>Unauthorized Access</h2>
        <p>This page is not assigned to you.</p>
        <p>Please contact your admin to request access.</p>
        <p>Redirecting back...</p>
      </div>
    );
  }

  return children;
};